import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useLangPath } from "../../hooks/useLangPath";

const Footer = () => {
    const { t } = useTranslation();
    const getPath = useLangPath();

    return (
        <>
            <footer className="footer-style4 v2">
                 <div className="footer-top4">
                    <div className="container">
                        <div className="footer-content4">
                            <h2 className="title">{t("Ready to build something intelligent?")}</h2>

                            <Link to={getPath('/contact')} className="ibt-btn ibt-btn-outline">
                                <span>{t("Start a Project")}</span>
                                <i className="icon-arrow-top"></i>
                            </Link>
                        </div>
                    </div>
                </div>

                <div className="widget-area ibt-section-gapTop">
                    <div className="container">
                        <div className="row">
                             <div className="col-lg-4">
                                <div className="about-widget4 footer-widget">
                                    <div className="footer-logo">
                                        <img src="/assets/images/logo.png"
                                            alt="WIZ Engineering"
                                            style={{ height: '230px', width: 'auto' }} />
                                    </div>
 
                                    <p>
                                        <span>©WIZ Engineering</span> 2026. {t("All rights reserved.")}
                                    </p>
                                </div>
                            </div>

                            <div className="col-lg-8">
                                <div className="footer-menu4">
                                     <div className="location-widget4 footer-widget">
                                        <h4 className="widget-title">{t("Headquarters")}</h4>
                                        <p>Palestine, Gaza, Jalaa st,<br />Watan Building 1107</p>

                                        <h5 className="title">{t("Follow Us")}</h5>
                                        <ul className="social-icon">
                                            <li><a href="https://www.facebook.com/wiztechnologyco" target="_blank" rel="noopener noreferrer" title="Facebook"><i className="fab fa-facebook-f"></i></a></li>
                                            <li><a href="https://www.instagram.com/wiz_smart_tech/" target="_blank" rel="noopener noreferrer" title="Instagram"><i className="fab fa-instagram"></i></a></li>
                                            <li><a href="https://www.linkedin.com/company/wiz-technology/" target="_blank" rel="noopener noreferrer" title="LinkedIn"><i className="fab fa-linkedin-in"></i></a></li>
                                        </ul>
                                    </div>

                                     <div className="contact-widget4 footer-widget">
                                        <h4 className="widget-title">{t("Let's Talk")}</h4>
                                        <a href="tel:+970595151005" className="nmbr">+970 595 151 005</a>

                                        <h5 className="widget-title" style={{ marginTop: '16px' }}>WhatsApp</h5>
                                        <a href="https://wa.me/970567960006" target="_blank" rel="noopener noreferrer" className="nmbr">+970 567 960 006</a>

                                        <h5 className="widget-title" style={{ marginTop: '16px' }}>{t("Email")}</h5>
                                        <a href="mailto:info@wiz-tech.co" className="gmail">info@wiz-tech.co</a>
                                    </div>

                                     <div className="footer-links footer-widget">
                                        <h4 className="widget-title">{t("Expertise")}</h4>
                                        <ul>
                                            <li><Link to={getPath('/products')}>{t("Our Products")}</Link></li>
                                            <li><Link to={getPath('/projects')}>{t("Projects")}</Link></li>
                                            <li><Link to={getPath('/services')}>{t("Engineering")}</Link></li>
                                            <li><Link to={getPath('/case-studies')}>{t("Case Studies")}</Link></li>
                                            <li><Link to={getPath('/contact')}>{t("Contact")}</Link></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
};

export default Footer;